<app-button
  [iconClass]="'fas fa-calendar-alt'"
  [label]="'admin.scheduleMeeting.actions.scheduleMeeting' | translate"
  [btnClass]="'btn btn-falcon-default btn-sm d-flex align-items-center gap-2'"
  (clicked)="openDialog()"
  [disabled]="btnDisabled() || isDisabled()"
  [attr.title]="
    !hasContact()
      ? ('admin.scheduleMeeting.tooltip.noContact' | translate)
      : null
  "
/>

@if (open()) {
<div
  class="modal modal-center d-block"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  (click)="closeDialog()"
>
  <div
    class="modal-dialog modal-dialog-centered modal-container"
    role="document"
    (click)="stopClose($event)"
  >
    <div class="modal-content" [ngClass]="{ 'accepted-bg': hasAccepted() }">
      <div class="modal-header border-0">
        <label class="section-title">
          {{ "admin.scheduleMeeting.actions.scheduleMeeting" | translate }}
        </label>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="closeDialog()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="form" (ngSubmit)="submit()">
          <div class="card">
            <div class="card-header">
              <h6 class="m-0">
                {{ "admin.scheduleMeeting.dates.title" | translate }}
              </h6>
            </div>
            <div class="mx-3">
              <app-validated-datetime-picker
                [label]="'admin.scheduleMeeting.dates.option1'"
                [inputFormControlName]="'option1'"
                [inputFormControl]="form.controls.option1"
                [leaveSpaceForValidation]="true"
                [ngClass]="{ accepted: acceptedIndex === 0 }"
              />
              <app-validated-datetime-picker
                [label]="'admin.scheduleMeeting.dates.option2'"
                [inputFormControlName]="'option2'"
                [inputFormControl]="form.controls.option2"
                [leaveSpaceForValidation]="true"
                [ngClass]="{ accepted: acceptedIndex === 1 }"
              />
              <app-validated-datetime-picker
                [label]="'admin.scheduleMeeting.dates.option3'"
                [inputFormControlName]="'option3'"
                [inputFormControl]="form.controls.option3"
                [leaveSpaceForValidation]="true"
                [ngClass]="{ accepted: acceptedIndex === 2 }"
              />
            </div>
          </div>

          <div class="mt-2">
            <app-validated-text-editor
              [label]="'admin.scheduleMeeting.message.title'"
              [inputFormControlName]="'messageHtml'"
              [inputFormControl]="form.controls.messageHtml"
              [leaveSpaceForValidation]="true"
            />
          </div>
        </form>
      </div>

      <div class="modal-footer border-0">
        <button
          type="button"
          class="btn btn-falcon-default btn-sm"
          [disabled]="sending()"
          (click)="closeDialog()"
        >
          {{ "general.cancel" | translate }}
        </button>

        <app-button
          [iconClass]="'fas fa-paper-plane'"
          [label]="'admin.scheduleMeeting.actions.send' | translate"
          [btnClass]="'btn btn-primary btn-sm d-flex align-items-center gap-2'"
          [disabled]="form.invalid || isDisabled() || readOnly"
          [loading]="sending()"
          (clicked)="submit()"
        />
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show"></div>
}
